var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMfaDownloadApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 74,
    viewBox: "0 0 48 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.51434 74H4.5166H42.6006C45.0938 74 47.1217 71.972 47.1217 69.4789V4.52112C47.1217 2.02795 45.0938 0 42.6006 0H4.5166H4.51434C2.12451 0 0 1.96177 0 4.5166C0.000907541 3.6061 0.00406225 16.7831 0 69.4834C0 71.9531 2.03025 74 4.51434 74ZM44.8092 59.7394H2.31702V12.0204H44.8092V59.7394ZM4.5166 71.6875C3.35893 71.6875 2.31702 70.7299 2.31702 69.4789V62.0519H44.8047V69.4834C44.8047 70.6989 43.8156 71.6875 42.6006 71.6875H4.5166ZM42.6006 2.3125C43.8156 2.3125 44.8047 3.30107 44.8047 4.5166V9.70787H2.31702V4.52112C2.31702 3.27826 3.35318 2.3125 4.5166 2.3125H42.6006Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.5587 63.2422C21.5623 63.2422 19.9375 64.8704 19.9375 66.8718C19.9375 68.8687 21.5623 70.4936 23.5587 70.4936C25.555 70.4936 27.1799 68.8687 27.1799 66.8718C27.1799 64.8704 25.555 63.2422 23.5587 63.2422ZM23.5587 68.1811C22.8372 68.1811 22.25 67.5939 22.25 66.8718C22.25 66.1458 22.8372 65.5547 23.5587 65.5547C24.2802 65.5547 24.8674 66.1458 24.8674 66.8718C24.8674 67.5939 24.2802 68.1811 23.5587 68.1811Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M27.2704 4.85352H19.8496V7.16602H27.2704V4.85352Z",
    fill: "#3E004A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.4084 18.7095H5.64062V32.4772H19.4084V18.7095ZM17.0959 30.1647H7.95313V21.022H17.0959V30.1647Z",
    fill: "#A35BB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.5411 24.437H11.5098V26.7495H13.5411V24.437Z",
    fill: "#A35BB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M19.4084 53.2384V39.4707H5.64062V53.2384H19.4084ZM7.95313 41.7832H17.0959V50.9259H7.95313V41.7832Z",
    fill: "#A35BB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.5411 45.1982H11.5098V47.5107H13.5411V45.1982Z",
    fill: "#A35BB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M22.8837 30.165H20.8535V32.4775H22.8837V30.165Z",
    fill: "#A35BB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M40.5431 18.7095H26.7754V32.4772H40.5431V18.7095ZM38.2306 30.1647H29.0879V21.022H38.2306V30.1647Z",
    fill: "#A35BB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M34.6739 24.437H32.6426V26.7495H34.6739V24.437Z",
    fill: "#A35BB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M22.8075 27.641H25.12V21.9603H23.0254V18.9138H20.7129V24.5946H22.8075V27.641Z",
    fill: "#A35BB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M13.8396 33.6255H9.71484V35.938H13.8396V33.6255Z",
    fill: "#A35BB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M20.9362 45.4236V49.8803H28.8764V37.9339H26.5639V39.4707H23.2487V36.1284H28.7567V33.8159H17.49V35.8467H14.666V38.1592H18.7919V36.1284H20.9362V43.4352H23.2487V41.7832H26.5639V43.0405H24.9063V45.353H26.5639V47.5678H23.2487V45.4236H20.9362Z",
    fill: "#A35BB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M30.6816 35.7471H32.503V39.4704H30.6816V41.7829H34.8155V35.7471H36.2958V43.3999H30.6816V45.7124H38.6083V43.6494H40.2997V41.3369H38.6083V39.8414H40.2997V37.5289H38.6083V35.7471H40.3291V33.4346H30.6816V35.7471Z",
    fill: "#A35BB1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M30.2871 51.2496H21.1602V53.5621H32.5996V49.3306H34.1375V52.8462H36.45V49.3306H37.9879V52.8462H40.3004V47.0181H30.2871V51.2496Z",
    fill: "#A35BB1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMfaDownloadApp);
export default __webpack_public_path__ + "static/media/MFADownloadApp.fd7be82e139b2657a463d30b3426a704.svg";
export { ForwardRef as ReactComponent };